import { APPOINTMENT_SALES, DUE_AMOUNT_REPORT, FILE_CREATE_REPORT, FILE_NOT_CREATE_REPORT, GET_APPOINTMENT_EXCEL_DATA, GET_DUE_EXCEL_DATA, GET_FILE_EXCEL_DATA, GET_FILE_NOT_EXCEL_DATA, GET_SALES_EXCEL_DATA, GET_TODAY_SALES, GET_USER_EXCEL_DATA, USER_REPORT, VIEW_REPORT } from "../actions/Report.action";

const initialState = {
    todaySales: '',
    appointmentSales: '',
    userReport: '',
    dueAmountReport: '',
    viewReport: '',
    fileCreateReport: '',
    fileNotCreateReport: '',
    getUserExcelData: '',
    getSalesExcelData:'',
    getDueExcelData:'',
    getAppointmentExcelData:'',
    getFileExcelReport: '',
    getFileNotExcelReport:''
}

const reportreducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_TODAY_SALES:
            return { ...state, todaySales: action.payload };
        case APPOINTMENT_SALES:
            return { ...state, appointmentSales: action.payload };
        case USER_REPORT:
            return { ...state, userReport: action.payload };
        case DUE_AMOUNT_REPORT:
            return { ...state, dueAmountReport: action.payload };
        case VIEW_REPORT:
            return { ...state, viewReport: action.payload };
        case FILE_CREATE_REPORT:
            return { ...state, fileCreateReport: action.payload };
        case FILE_NOT_CREATE_REPORT:
            return { ...state, fileNotCreateReport: action.payload };
        case GET_USER_EXCEL_DATA:
            return { ...state, getUserExcelData: action.payload };
        case GET_SALES_EXCEL_DATA:
            return { ...state, getSalesExcelData: action.payload };
        case GET_DUE_EXCEL_DATA:
            return { ...state, getDueExcelData: action.payload };
        case GET_APPOINTMENT_EXCEL_DATA:
            return { ...state, getAppointmentExcelData: action.payload };
        case GET_FILE_EXCEL_DATA:
            return { ...state, getFileExcelReport: action.payload };
        case GET_FILE_NOT_EXCEL_DATA:
            return { ...state, getFileNotExcelReport: action.payload };
        default:
            return state;
    }
}

export default reportreducer;